import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { RESULT_CODE } from "../core/constants";
import { translate } from "../core/i18n";
import { getDomainCfg, store } from "../core/state";

export function ResultCode() {
  const [resultCodeData] = store.useState(RESULT_CODE);
  const [showResultCode, setShowResultCode] = useState(false);
  const resultCodeInputRef : any = useRef();
  if (getDomainCfg().viewSettings.features.showResultCode === false) {
    return null;
  }

  const showResultCodeArea = () => {
    setShowResultCode(true);
  }

  const copyResultCode = () => {
    const copyInput : any  = resultCodeInputRef.current;
    console.log("copy result code:", typeof(resultCodeInputRef.current));
    copyInput.select();
    copyInput.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
  }

  const link = <p className="resultCodeLink">{translate("app-key-title")}</p>;
  const area = (
    <div>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon2">{translate("app-key-input")}</span>
        <input type="text" className="form-control" ref={resultCodeInputRef} onClick={copyResultCode} aria-describedby="resultCodeText" value={resultCodeData.code} placeholder={translate("app-key-input")} readOnly />
        <span className="input-group-text" onClick={copyResultCode} ><FontAwesomeIcon icon="copy" /></span>
      </div>
    </div>
  );
  return (
    <div onClick={showResultCodeArea}>
      { !showResultCode && link}
      { showResultCode && area}
    </div>);
}
